// extracted by mini-css-extract-plugin
export default {"error":"error--64cfee9","errorIcon":"errorIcon--651bfe1"};